import Immutable from "immutable";
import { IPaginationStore } from "../PaginationStore";
import { StoreProductPayload, StoreProductStore } from "./StoreProductStore";
import PaginationItemListStore from "../PaginationItemListStore";

export interface StoreProductTypePayload {
  id: number
  name: string
}

export interface StoreProductListPayload {
  dataType: 'storeProducts',
  items: StoreProductPayload[],
  totalItems: number
  productTypes?: StoreProductTypePayload[]
}

export interface IStoreProductListStore extends IPaginationStore {
  data: Immutable.Map<string, StoreProductStore>,
}

const defaultStoreProductListStore = Immutable.Record<IStoreProductListStore>({
  itemLists: Immutable.Map<string, PaginationItemListStore>(),
  data: Immutable.Map<string, StoreProductStore>(),
});

export default class StoreProductListStore extends defaultStoreProductListStore implements IStoreProductListStore { }
